// Reducer extracted from NavigationModule.js

import update from "immutability-helper";
import { UPDATE_NAVIGATION_OBJECT } from "./NavigationConstants";

// Initial State
const initialState = {
  navigationObject: {
    showLeCommentBox: null,
    showAssessmentCommentBox: null,
    unitPlanCommentBox: null,
    unitPlanStepRoute: null,
    postDetail: null,
    chatBox: null,
    calendarEventModal: null,
    projectCommentBox: null,
    snpChatDetails: null,
    attendanceDate: null,
    excusalId: null,
    periodId: null,
    courseId: null,
    calendarEventDetails: null,
    curriculumProgramId: null,
  },
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [UPDATE_NAVIGATION_OBJECT]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        navigationObject: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
